import { ref, onMounted } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import Header from '@/views/layout/header.vue';
import Player from './player/index.vue';
// import Player from './player/index.test.vue'
import ChatList from './chatList/index.vue';
import ChatBox from './chatBox/index.vue';
import ConnectTimeout from '@/views/chat/connectTimeout.vue';
import store from '@/store';
import roleHooks from '@/hooks/roleHooks';
import userHooks from '@/hooks/userHooks';
import bus from '@/utils/mitt.js';
import { getmark } from '@/utils/watermark';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      watermark
    } = getmark();
    const {
      isShowLeft,
      isShowRight
    } = roleHooks();
    const {
      initAllRoleList,
      setIsShowLeft,
      setIsShowRight,
      showAvatar
    } = roleHooks();
    const {
      wwid
    } = userHooks();
    const player = ref(null);
    const chatbox = ref(null);
    const chatlist = ref(null);
    const isConnectError = ref(false);
    const errorType = ref();
    onMounted(() => {
      var _store$state;
      initAllRoleList();
      const wwid = (_store$state = store.state) === null || _store$state === void 0 ? void 0 : _store$state.userInfo.userInfo.unionNo;
      watermark([wwid, '内容由AI生成，仅供参考']); //水印名
    });

    const connectError = e => {
      isConnectError.value = true;
      errorType.value = e;
      bus.emit('flvEnd', true);
    };
    const getAudioStream = blob => {
      player.value.audioBlob(blob);
    };
    const closeShow = () => {
      setIsShowLeft(false);
      setIsShowRight(false);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "chat_container",
        onClick: closeShow
      }, [_createVNode(Header), _createVNode(Player, {
        ref_key: "player",
        ref: player,
        onConnectError: connectError
      }, null, 512), _createVNode(ChatList, {
        ref_key: "chatlist",
        ref: chatlist
      }, null, 512), _createVNode(ChatBox, {
        ref_key: "chatbox",
        ref: chatbox,
        onUploadAudioStream: getAudioStream
      }, null, 512)]), _unref(isConnectError) ? (_openBlock(), _createBlock(ConnectTimeout, {
        key: 0,
        errorType: _unref(errorType),
        onChangeStatus: _cache[0] || (_cache[0] = $event => isConnectError.value = false)
      }, null, 8, ["errorType"])) : _createCommentVNode("", true)], 64);
    };
  }
});